/** @format */

import axios from 'axios';
import { ListedLead, ListedLeadFormInput, ListedLeadFilterInput } from '../types/listedLeads.types';

const apiUrl = process.env.REACT_APP_SIADASH_BACKEND_URL;

/**
 * Get listed leads with optional filtering
 */
export const getListedLeads = async (filter?: ListedLeadFilterInput): Promise<ListedLead[]> => {
  const token = localStorage.getItem('accessToken');
  console.log('Fetching listed leads with filter:', filter);
  const response = await axios.get(`${apiUrl}/api/leads/listed-leads`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: filter,
  });
  console.log('Listed leads fetched:', response.data);
  return response.data;
};

/**
 * Get listed lead by ID
 */
export const getListedLeadById = async (id: string): Promise<ListedLead> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${apiUrl}/api/leads/listed-leads/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Create a single listed lead
 */
export const createListedLead = async (listedLead: ListedLeadFormInput): Promise<ListedLead> => {
  const token = localStorage.getItem('accessToken');
  console.log('Creating listed lead:', listedLead);
  const response = await axios.post(`${apiUrl}/api/leads/listed-leads`, listedLead, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  console.log('Listed lead created:', response.data);
  return response.data;
};

/**
 * Create multiple listed leads in batch
 */
export const batchCreateListedLeads = async (listedLeads: ListedLeadFormInput[]): Promise<ListedLead[]> => {
  const token = localStorage.getItem('accessToken');
  console.log('Submitting listed leads:', listedLeads);
  const response = await axios.post(`${apiUrl}/api/leads/listed-leads`, listedLeads, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  console.log('Listed leads created:', response.data);
  return response.data;
};

/**
 * Update a listed lead
 */
export const updateListedLead = async (id: string, listedLead: Partial<ListedLeadFormInput>): Promise<ListedLead> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.put(`${apiUrl}/api/leads/listed-leads/${id}`, listedLead, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

/**
 * Delete a listed lead
 */
export const deleteListedLead = async (id: string): Promise<ListedLead> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.delete(`${apiUrl}/api/leads/listed-leads/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
